import React from 'react';

import CardDialog from '~/components/CardDialog';
import type { Policy, PolicyApiV2SelectResult, PolicyData } from '~/components/Fnol/FnolAiInbox/types';
import { PolicySearchResults } from '~/components/PolicySearch';
import { PolicySearchResultsV2 } from '~/components/PolicySearchV2';
import POLICY_SEARCH_ENVELOPE_KINDS from '~/server_shared/generated-types/POLICY_SEARCH_ENVELOPE_KINDS';

interface PolicyCardProps {
  policy: Policy;
  onChangePolicy: () => void;
  onCancel: () => void;
  viewOnly: boolean;
}

function ClivePolicyV2SearchResults({
  policyData,
  onCancel,
  onChangePolicy,
  disableSelectButton,
}: {
  policyData: unknown;
  onCancel: () => void;
  onChangePolicy: () => void;
  disableSelectButton: boolean;
}) {
  const PolicyApiV2SelectResult = policyData as PolicyApiV2SelectResult;
  const lob = (PolicyApiV2SelectResult.policy_api_data as PolicyData).lob;

  return (
    <PolicySearchResultsV2
      isDialog={false}
      noCardTitle
      searchPoliciesResults={{ [lob]: PolicyApiV2SelectResult.policy_search_response }}
      onCancel={onCancel}
      /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
      onSelectPolicy={(_selectedPolicy) => Promise.resolve(onChangePolicy())}
      policyTypes={[lob]}
      selectButtonText="Change"
      disableSelectButton={disableSelectButton}
    />
  );
}

export const PolicyCard: React.FC<PolicyCardProps> = ({
  policy,
  onChangePolicy,
  onCancel,
  viewOnly = false,
}: PolicyCardProps) => {
  const resultsDict = {
    [policy.policy_type]: [policy],
  };

  // The envelope says which shape it is. Rows stored before the v1 marker existed carry none, and
  // those are v1 — the same legacy reading `_envelope_shape` applies on the server.
  const envelopeKind = policy.response_payload_version_key ?? POLICY_SEARCH_ENVELOPE_KINDS.V1;

  return (
    <CardDialog isDialog title="Policy Found" onClose={onCancel} maxWidth="lg" fullWidth>
      <div className="flex flex-col gap-12">
        {envelopeKind === POLICY_SEARCH_ENVELOPE_KINDS.V1 && (
          <PolicySearchResults
            isDialog={false}
            noCardTitle
            classes={{}}
            searchPoliciesResults={resultsDict}
            onSelectPolicy={onChangePolicy}
            policyTypes={[policy.policy_type]}
            selectButtonText="Change"
            disableSelectButton={viewOnly}
          />
        )}
        {/* Checked explicitly rather than as the v1 fallthrough: a kind neither table can bind renders
            no table, as the server's `_envelope_shape` refuses a marker it does not recognise. */}
        {envelopeKind === POLICY_SEARCH_ENVELOPE_KINDS.V2 && (
          <ClivePolicyV2SearchResults
            policyData={policy}
            onCancel={onCancel}
            onChangePolicy={onChangePolicy}
            disableSelectButton={viewOnly}
          />
        )}
      </div>
    </CardDialog>
  );
};
